import { type FC } from 'react';
import type { SportSB } from '@mwl/core-lib';
import { selectSportsWithLines, useItemsFilteredByStage, useSportUrlParams } from '@mwl/core-lib';
import { useIsCyberSportPage, useIsSportHistoryPage, useMediaWidthDown, useTypedSelector } from '@/hooks';
import { DesktopSportToolbar } from './DesktopSportToolbar/DesktopSportToolbar';
import { MobileSportToolbar } from './MobileSportToolbar/MobileSportToolbar';
import type { SportToolbarProps } from './SportToolbar.types';
import styles from './SportToolbar.module.scss';
const SportToolbar: FC<SportToolbarProps> = ({
  className,
  hideToolbarFilters,
  hideAdditionalToolbarFilters
}) => {
  const isXsScreen = useMediaWidthDown('screen850');
  const isSportHistoryPage = useIsSportHistoryPage();
  const isCyberSportPage = useIsCyberSportPage();
  const {
    stage
  } = useSportUrlParams();
  const sports = useTypedSelector(state => selectSportsWithLines(state, isCyberSportPage ? 'CYBER' : undefined));
  const filteredSports = useItemsFilteredByStage<SportSB>(sports, stage);
  return <div className={cn(styles.root, className)} data-sentry-component="SportToolbar" data-sentry-source-file="SportToolbar.tsx">
      {(isXsScreen || isXsScreen && isSportHistoryPage) && <MobileSportToolbar sports={filteredSports} className={styles.mobileToolbar} hideAdditionalToolbarFilters={hideAdditionalToolbarFilters} hideToolbarFilters={hideToolbarFilters} />}
      {!isXsScreen && !hideToolbarFilters && !isSportHistoryPage && <DesktopSportToolbar sports={filteredSports} className={styles.desktopToolbar} />}
    </div>;
};
export { SportToolbar };